import CustomReactTable from "components/Templates/CustomReactTable"
import { useExtraSkusQuery } from "generated/graphql"
import React from "react"

const SkuTable = ({ tripId }) => {
  const { data: tripDetails } = useExtraSkusQuery({ variables: { tripId } })

  const COLUMNS = [
    {
      Header: "SKU",
      accessor: "sku.name",
      Cell({ value }) {
        return <div className="vt-text-center">{value}</div>
      },
    },
    {
      Header: "Quantity",
      accessor: "quantity",
      Cell({ value }) {
        return (
          <>
            <div className="vt-text-center">{`${value}`}</div>
          </>
        )
      },
    },
  ]

  return (
    <div>
      <CustomReactTable
        className="vt-dms-react-table"
        data={(tripDetails?.tripDetails as any)?.extraSku}
        columns={COLUMNS}
      />
    </div>
  )
}

export default SkuTable
